import { render, staticRenderFns } from "./ServiceProvidersView.vue?vue&type=template&id=d2a5d942&scoped=true&lang=pug&"
import script from "./ServiceProvidersView.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvidersView.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProvidersView.vue?vue&type=style&index=0&id=d2a5d942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a5d942",
  null
  
)

export default component.exports